import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal, Space } from 'antd';
import axios from 'axios';
import { useState } from 'react';

export default function BrandDelModal({ brand, open, setOpen, onDeleted }) {
   const [deleting, setDeleting] = useState(false);

   async function handleDelete() {
      setDeleting(true);
      await axios
         .delete(`/api/brands/${brand.id}`)
         .then((res) => {
            setDeleting(false);
            setOpen(false);
            onDeleted(brand.id);
         })
         .catch((err) => {
            setDeleting(false);
         });
   }

   return (
      <>
         <Modal
            title={
               <Space size="small">
                  <ExclamationCircleFilled style={{ color: '#FF4D4F' }} />
                  Delete Brand
               </Space>
            }
            open={open}
            okText="Delete"
            okButtonProps={{ danger: true, type: 'primary' }}
            onOk={handleDelete}
            cancelText="Cancel"
            onCancel={() => setOpen(false)}
            confirmLoading={deleting}
         >
            <p>Deleting this brand will delete all the uploaded assets permanently,</p>
            <p>Are you sure you want to delete this brand?</p>
         </Modal>
      </>
   );
}
